import React from 'react'
import styled from 'styled-components'

import { useFeature } from '../../store/features'
import { getProductPickerMenuItems } from './ProductPickerService'
import DropdownMenu from '../design-system/DropdownMenu/DropdownMenu'
import SvgIcon from '../design-system/Icon/SvgIcon'

export const ProductPicker: React.FC = () => {
  const isVoiceBuilderEnabled = !!useFeature('VOICE_BUILDER')

  const menuItems = getProductPickerMenuItems(isVoiceBuilderEnabled)

  if (!menuItems.length) {
    return null
  }

  return (
    <>
      <StyledDropdownMenu items={menuItems}>
        <Menu>
          <SvgIcon name={'menu'} />
        </Menu>
      </StyledDropdownMenu>
    </>
  )
}

const StyledDropdownMenu = styled(DropdownMenu)`
  font-weight: bold;
`

const Menu = styled.div`
  margin: 25px 25px 19px 35px;
  cursor: pointer;
`
